import * as React from 'react';
const SvgMerch = (props) => (
  <svg viewBox="0 0 124 125" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m87.449 51.424-4.974 14.673c-.19.553-.09 1.165.259 1.634L92 80.149c.88 1.18.026 2.855-1.449 2.84l-15.49-.2a1.791 1.791 0 0 0-1.474.748l-8.946 12.65c-.849 1.201-2.708.906-3.146-.5l-4.599-14.795a1.779 1.779 0 0 0-1.17-1.17l-14.794-4.6c-1.406-.437-1.701-2.297-.5-3.145l12.65-8.946c.479-.337.758-.89.748-1.475l-.2-15.49c-.022-1.47 1.66-2.33 2.84-1.45l12.417 9.268c.469.348 1.08.448 1.633.258l14.673-4.973c1.396-.474 2.724.859 2.255 2.255Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.132 14.843 24.305 4.67a6.676 6.676 0 0 1 6.29-1.765l26.559 6.444c1.19.29 2.276.901 3.145 1.77l59.745 59.748a6.668 6.668 0 0 1 0 9.436l-40.457 40.464a6.679 6.679 0 0 1-9.436 0l-59.75-59.753a6.687 6.687 0 0 1-1.765-3.145L2.188 31.313a6.676 6.676 0 0 1 1.77-6.296l5.711-5.711"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.784 20.033a8.068 8.068 0 0 1 4.162 13.63 8.07 8.07 0 1 1-11.411-11.417M2.003 2.715l25.236 25.237"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgMerch;
